import { render } from "./LastWeekTabCont.vue?vue&type=template&id=4c05b4da"
import script from "./LastWeekTabCont.vue?vue&type=script&lang=js"
export * from "./LastWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__